var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('v-divider',{attrs:{"color":_vm.lineColor}}),_c('span',{class:'caption' + _vm.color},[_vm._v(_vm._s(_vm.text))]),_c('v-divider',{attrs:{"color":_vm.lineColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }